<i18n>
{
	"en": {
		"PleaseInputToSearch": "Please input to search"
	},
	"vi": {
		"PleaseInputToSearch": "Không có kết quả phù hợp."
	}
}
</i18n>

<template>
	<div>
		<!-- Block tag employee, departement, title -->
		<div class="container-watcher--block-item">
			<h6 v-if="title" class="mb-2 custom-component--title">{{ title }}<span class="text-danger" v-if="isRequired">&nbsp;*</span>:</h6>
			<v-select
				:clearable="false"
				:ref="ref"
				label="name"
				v-bind="$attrs"
				v-on="$listeners"
				:options="titles"
				:placeholder="placeholder"
				class="bg-white"
				:closeOnSelect="true"
				:getOptionKey="option => ref + option.id"
				:reduce="title => ({ id: title.id, name: title.name })"
			>
				<template #option="{ name }">
					<div>
						{{ name }}
					</div>
				</template>
				<template #selected-option="{ name}">
					<p>{{ name }}</p>
				</template>
				<template #no-options>
					{{ noOptionsTitle ? noOptionsTitle : $t("PleaseInputToSearch") }}
				</template>
			</v-select>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

import * as _ from "lodash";

export default {
	inheritAttrs: false,
	name: "CbsEmployeeTitles",
	props: {
		title: {
			type: String
		},
		placeholder: {
			type: String
		},

		noOptionsTitle: {
			type: String
		},
		isRequired: {
			type: Boolean
		},
		modelId: Number,
		modelType: String
	},
	components: {
		"v-select": vSelect
	},
	computed: {
		titles() {
			return this.$store.state.titleManagement.titles;
		}
	},

	data() {
		return {
			ref: _.uniqueId("employeeTitles_")
		};
	}
};
</script>
<style lang="scss">
.container-watcher--block-item {
	.vs__selected {
		.inline-block {
			line-height: 100%;
		}
		.nucleo {
			color: var(--color-white);
		}
	}
}
</style>
